import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';


// import Button from '@material-ui/core/Button';
// import Hidden from '@material-ui/core/Hidden'

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
// import Language from '@material-ui/icons';



import './header.css'

export default class MobileHomeRightPane extends Component {
  state = {
    anchorEl: null,
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    return (
      <div>
        <IconButton 
        className={css(styles.MenuButton)}
        aria-owns={anchorEl ? 'simple-menu' : null}
        aria-haspopup="true"
        onClick={this.handleClick}>
          <MenuIcon />
        </IconButton>   
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.handleClose}>Portfolio</MenuItem>
          <MenuItem onClick={this.handleClose}>Solutions</MenuItem>
          <MenuItem onClick={this.handleClose}>Team</MenuItem>
          <MenuItem onClick={this.handleClose}>Achievements</MenuItem>
          <MenuItem onClick={this.handleClose}>Contact</MenuItem>
        </Menu>
      </div>
    );
  }
}
const styles = StyleSheet.create({
    MenuButton : {
      color: '#4985f2',
      textTransform: 'capitalize'
    }
});


// WEBPACK FOOTER //
// ./src/Components/Header/InvertedMobileHomeRightPane.js